import React from "react";
import "./about-residents.css";
import SectionContainer from "../../../components/landing/section-container";
import { Grid, Typography } from "@mui/material";
import Salvador from "../../../assets/flags/Salvador.png";
import CostaRica from "../../../assets/flags/CostaRica.png";
import Mexico from "../../../assets/flags/Mexico.webp";
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import Latina from "../../../assets/flags/Latina.png";
import Fidelitas from "../../../assets/flags/Fidelitas.jpg";
import LogoUCR from "../../../assets/flags/LogoUCR.png";

function AboutResidentsPage () {
    return (
        <SectionContainer id="about-residents" title="Acerca de nuestros residentes">
          <Grid container spacing={2}>
            <Grid item xs={8}>  
              <Typography>
              En nuestra residencia estudiantil, nos enorgullece ofrecer un hogar a estudiantes de diversas universidades y orígenes. Nuestros residentes provienen de instituciones de prestigio como la Universidad de Costa Rica (UCR), la Universidad Latina y la Universidad Fidelitas. 
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Stack direction={{ xs:'column', sm:'row'}} spacing={4} justifyContent="center" textAlign="center">
                  <Avatar sx={{ width: 60, height: 30 }} alt="UCR" src={LogoUCR} variant="square"/>
                  <Avatar sx={{ width: 60, height: 30 }} alt="Latina" src={Latina} variant="square"/>
                  <Avatar sx={{ width: 60, height: 30 }} alt="Fidelitas" src={Fidelitas} variant="square"/>
              </Stack>
            </Grid>
            <Grid item xs={8}>
              <Typography>
              Además, hemos tenido el honor de recibir estudiantes internacionales provenientes de países como México y El Savador, así como muchos residentes nacionales de diversas partes de Costa Rica. 
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Stack direction={{ xs:'column', sm:'row'}} spacing={4} justifyContent="center" textAlign="center">
                  <Avatar sx={{ width: 60, height: 30 }} alt="Costa Rican flag" src={CostaRica} variant="square"/>
                  <Avatar sx={{ width: 60, height: 30 }} alt="Salvador" src={Salvador} variant="square"/>
                  <Avatar sx={{ width: 60, height: 30 }} alt="Mexico" src={Mexico} variant="square"/>
              </Stack>
            </Grid>
          </Grid>
      </SectionContainer>
    )
}

export default AboutResidentsPage;